import { To } from "react-router-dom";

export enum BackPageButtonSearchParamName {
  VACANCY_ID = "vacancyId",
  CANDIDATE_ID = "candidateId",
  EXAMINATION_ID = "examinationId",
  TRIAL_ID = "trialId",
  COMPETENCY_MAP_ID = "competencyMapId",
  COMPETENCY_MAPS_LIST = "competencyMapsList",
  KNOWLEDGE_BLOCK_ID = "knowledgeBlockId",
}

export interface BackPageButtonSearchParams {
  [BackPageButtonSearchParamName.VACANCY_ID]?: string;
  [BackPageButtonSearchParamName.CANDIDATE_ID]?: string;
  [BackPageButtonSearchParamName.EXAMINATION_ID]?: string;
  [BackPageButtonSearchParamName.TRIAL_ID]?: string;
  [BackPageButtonSearchParamName.COMPETENCY_MAP_ID]?: string;
  [BackPageButtonSearchParamName.COMPETENCY_MAPS_LIST]?: boolean;
  [BackPageButtonSearchParamName.KNOWLEDGE_BLOCK_ID]?: string;
}

export type BackPageButtonValue = {
  text: string;
  link: To;
};
